import gql from 'graphql-tag';

export const UPDATE_BUSINESS_PROCESS_FLOW_TEMPLATE = gql`
  mutation UpdateBusinessProcessFlowTemplate($input: UpdateBusinessProcessFlowTemplateInput!) {
    updateBusinessProcessFlowTemplate(input: $input) {
      businessProcessFlowId
    }
  }
`;
